import { makeAutoObservable } from "mobx"

export default class DraftUpload {

  constructor(draftUpload = {}) {
    this.id = draftUpload.id
    this.fileName = draftUpload.file_name
    this.isArchived = draftUpload.is_archived
    this.url = draftUpload.url
    this.fileType = draftUpload.file_type
    this.videoThumb = draftUpload.video_thumb || null
    this.commentLocations = []

    makeAutoObservable(this)
  }
}
